import { useEffect, useRef } from 'react'
import { clamp, onScrollFrame } from '@/lib/scroll'

/**
 * Sticky stacked cards: as the next card slides over, the covered one gives way, shrinking a
 * touch and fading back into the cream through its `--dim` variable. Runs from 768px up and
 * never with reduced motion. Attach the returned refs to the cards in order.
 */
export const useStackGiveWay = (stickyTop: number) => {
    const cardRefs = useRef<Array<HTMLElement | null>>([])

    useEffect(() => {
        const wide = window.matchMedia('(min-width: 768px)')
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        return onScrollFrame(() => {
            const cards = cardRefs.current

            cards.forEach((card, index) => {
                if (!card) return

                const next = cards[index + 1]

                if (!wide.matches || reduced || !next) {
                    card.style.transform = ''
                    card.style.setProperty('--dim', '0')

                    return
                }

                const height = card.offsetHeight
                const progress = clamp((stickyTop + height - next.getBoundingClientRect().top) / height)

                card.style.transform = progress > 0.001 ? `scale(${(1 - progress * 0.05).toFixed(4)})` : ''
                card.style.setProperty('--dim', (progress * 0.45).toFixed(3))
            })
        })
    }, [stickyTop])

    return cardRefs
}
